"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgebraFactory = exports.algebraUtils = exports.transformer = exports.isKnownSubType = exports.isKnownOperation = exports.Algebra = void 0;
exports.Algebra = __importStar(require("./Algebra"));
var utils_1 = require("./utils");
Object.defineProperty(exports, "isKnownOperation", { enumerable: true, get: function () { return utils_1.isKnownOperation; } });
Object.defineProperty(exports, "isKnownSubType", { enumerable: true, get: function () { return utils_1.isKnownSubType; } });
Object.defineProperty(exports, "transformer", { enumerable: true, get: function () { return utils_1.transformer; } });
__exportStar(require("./TypesComunica"), exports);
exports.algebraUtils = __importStar(require("./utils"));
var AlgebraFactory_1 = require("./AlgebraFactory");
Object.defineProperty(exports, "AlgebraFactory", { enumerable: true, get: function () { return AlgebraFactory_1.AlgebraFactory; } });
//# sourceMappingURL=index.js.map